import { useState, useEffect, useCallback, useRef } from 'react';
import { authHeaders } from '../services/auth';

const WORKER_URL = process.env.REACT_APP_WORKER_URL || '';
const POLL_MS    = 30000;

export function useNotifications(user) {
  const [notifications, setNotifications] = useState([]);
  const [groupUsers,    setGroupUsers]    = useState([]);
  const [toast,         setToast]         = useState(null);
  const toastTimer = useRef(null);

  const showToast = useCallback((msg) => {
    setToast(msg);
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToast(null), 3500);
  }, []);

  const fetchNotifications = useCallback(async () => {
    if (!user) return;
    try {
      const r = await fetch(`${WORKER_URL}/api/notifications`, { headers: authHeaders(), credentials: 'include' });
      if (r.ok) { const d = await r.json(); setNotifications(d.notifications || []); }
    } catch {}
  }, [user]);

  const fetchUsers = useCallback(async () => {
    if (!user) return;
    try {
      const r = await fetch(`${WORKER_URL}/api/users`, { headers: authHeaders(), credentials: 'include' });
      if (r.ok) { const d = await r.json(); setGroupUsers(d.users || []); }
    } catch {}
  }, [user]);

  useEffect(() => {
    if (!user) return;
    fetchNotifications();
    fetchUsers();
    const iv = setInterval(fetchNotifications, POLL_MS);
    return () => { clearInterval(iv); clearTimeout(toastTimer.current); };
  }, [user, fetchNotifications, fetchUsers]);

  const sendNotification = useCallback(async (toUserId, toUsername, type, itemTitle, itemId) => {
    try {
      const r = await fetch(`${WORKER_URL}/api/notifications`, {
        method:      'POST',
        headers:     { 'Content-Type': 'application/json', ...authHeaders() },
        credentials: 'include',
        body:        JSON.stringify({ toUserId, type, itemTitle, itemId }),
      });
      if (r.ok) showToast(`${itemTitle} → ${toUsername}`);
    } catch {}
  }, [showToast]);

  const respondNotification = useCallback(async (notifId, status) => {
    try {
      await fetch(`${WORKER_URL}/api/notifications/${notifId}`, {
        method:      'PUT',
        headers:     { 'Content-Type': 'application/json', ...authHeaders() },
        credentials: 'include',
        body:        JSON.stringify({ status }),
      });
      setNotifications(prev => prev.map(n => n.id === notifId ? { ...n, status } : n));
    } catch {}
  }, []);

  const pendingCount = notifications.filter(n => n.status === 'pending').length;

  return { notifications, groupUsers, pendingCount, toast, sendNotification, respondNotification };
}
